export default {
  buttons: {
    remove: 'Remove',
  },
  title: 'Promo code or Gift card',
};
